export const decodePathname = (pathname: string): string => {
    try {
        return pathname
            .split("/")
            .map(segment => decodeURIComponent(segment).replace(/\//g, "%2F"))
            .join("/");
    } catch {
        return pathname;
    }
};
